// extracted by mini-css-extract-plugin
export default {"badge":"NotificationBadge_badge__o7LtC","badgeBounce":"NotificationBadge_badgeBounce__leDgH","badgePulse":"NotificationBadge_badgePulse__sH678"};